define('glu/layout',['require','./$','marionette','./core/internal/viewMixins'],function(require) {
    'use strict';

    var $ = require('./$'),
        Marionette = require('marionette'),
        Region = Marionette.Region,
        viewMixins = require('./core/internal/viewMixins');

    var Mixin = viewMixins(Marionette.Layout);

    return Marionette.Layout.extend(Mixin).extend({

        bindUIElements: function(options) {
            Marionette.Layout.prototype.bindUIElements.call(this, options);
            this.setupRegions();
        },

        setupRegions: function() {
            var self = this;
            var cache = {};

            this.$('[data-region]').each(function() {
                var regionName = $(this).data('region');
                if (typeof self[regionName] === 'undefined') {
                    self.addRegion(regionName, '[data-region="' + regionName + '"]');
                } else if (!(self[regionName] instanceof Region)) {
                    throw new Error('Cannot use region name "' + regionName + '". Already defined.');
                } else if (cache[regionName]) {
                    throw new Error('Defined the region "' + regionName + '" Twice within the template');
                }
                cache[regionName] = true;
            });
        }
    });
});

